import { Log } from './logging';

declare global {
    interface Navigator {
        msSaveOrOpenBlob?: (blob: any, defaultName?: string) => boolean
    }
}
export interface EksamensFileQuery {
    ExSPSiteURL: string;
    ExListID: string;
    ExListItemID: string;
    ExUIVersionStringOWSTEXT: string;
    ExIsPasswordProtected: string;
    ExPassord?: string;
    DocumentGuid: string;
    modalpassword?: string;
    filnavn: string;
    innholdstype?: string;
    updateStatus: (status: EksamenFileStatus) => void
}

export enum EksamenFileStatus {
    NoAction,
    CorrectPassword,
    WrongPassword,
    ServerError,
    DownloadError,
    Downloaded,
    DownloadStarted
}

// eslint-disable-next-line
async function getEksamenFileOld(query: EksamensFileQuery) {
    query.updateStatus(EksamenFileStatus.DownloadStarted);

    Log("Laster ned            : " + query.ExSPSiteURL);
    Log("ListID                : " + query.ExListID);
    Log("ListItemID            : " + query.ExListItemID);
    Log("UIVersionStringOWSTEXT: " + query.ExUIVersionStringOWSTEXT);
    Log("modalpassword         : " + query.modalpassword);
    Log("IsPasswordProtected   : " + query.ExIsPasswordProtected);
    Log("Passord               : " + query.ExPassord);
    Log("FileName              : " + query.filnavn);

    Log(query.modalpassword);
    const bearertokenResult = await geteksamensoppgavefrompgsd(query.ExSPSiteURL, query.ExListID, query.ExListItemID, query.DocumentGuid, query.ExUIVersionStringOWSTEXT, query.modalpassword, query.ExIsPasswordProtected, query.ExPassord)
    const bearertoken = await bearertokenResult.text();
    Log("BEARER TOKEN:");
    Log(bearertoken);
    if (bearertoken.toString() === "Feil passord" || bearertoken.toString().indexOf("Feil passord") !== -1) {
        Log("Wrong password: " + query.modalpassword);
        query.updateStatus(EksamenFileStatus.WrongPassword);
        return;
    } else {
        query.updateStatus(EksamenFileStatus.CorrectPassword);
    }
    var xhr = new XMLHttpRequest();
    //var url = "https://udir-pgsd-file-test.azurefd.net/api/Get-File";
    var url = "https://udir-pgsd-test.azurefd.net/api/Get-File";
    if (query.ExSPSiteURL.indexOf("test-pgsd") !== -1) {
        url = "https://udir-pgsd-test.azurefd.net/api/Get-File";
    } else if (query.ExSPSiteURL.indexOf("qa-pgsd2") !== -1 || query.ExSPSiteURL.indexOf("qa-pgsd") !== -1) {
        url = "https://udir-pgsd-qa.azurefd.net/api/Get-File";
    } else if (query.ExSPSiteURL.indexOf("imp-pgsd") !== -1) {
        url = "https://udir-pgsd-qa.azurefd.net/api/Get-File";
    } else if (query.ExSPSiteURL.indexOf("pgsd2") !== -1 || query.ExSPSiteURL.indexOf("pgsd") !== -1) {
        url = "https://udir-pgsd.azurefd.net/api/Get-File";
    }

    Log("FILE-API-URL:" + url);
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.setRequestHeader("Authorization", bearertoken);
    xhr.onreadystatechange = function () {
        Log("Inside onreadystatechange");
        Log(xhr);
        if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 202)) {
            query.updateStatus(EksamenFileStatus.CorrectPassword);
            var jsondata = JSON.parse(xhr.responseText);
            Log(jsondata);

            var applicationType = jsondata.MimeType;
            var binaryFile = jsondata.FileBinary;
            var binaryFileDecoded = atob(binaryFile);
            var byteNumbers = new Array(binaryFileDecoded.length);
            for (var i = 0; i < binaryFileDecoded.length; i++) {
                byteNumbers[i] = binaryFileDecoded.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);

            var file = new Blob([byteArray], { type: applicationType });
            Log("BLOB BLOB BLOB BLOB BLOB BLOB BLOB BLOB BLOB BLOB BLOB");
            if (file.size > 0) {
                Log(query.innholdstype);
                if(query.modalpassword && query.innholdstype !== "Sensorskolering") {
                    sessionStorage.setItem('udirsokeksamensessionpassword', query.modalpassword);
                }
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    Log("MOBILE DOWNLOAD");
                    window.parent.location.href = URL.createObjectURL(file);
                    query.updateStatus(EksamenFileStatus.Downloaded);
                }
                //@ts-ignore
                else if (window.navigator.msSaveOrOpenBlob) {  // For IE
                    Log("IE DOWNLOAD:" + query.filnavn);
                    window.navigator.msSaveOrOpenBlob(file, query.filnavn);
                    query.updateStatus(EksamenFileStatus.Downloaded);
                }
                else {
                    Log("OTHER DOWNLOAD 2");
                    var a = window.document.createElement("a");
                    a.href = window.URL.createObjectURL(file);
                    a.download = query.filnavn;
                    Log(query.filnavn);
                    document.body.appendChild(a);
                    a.click();  // IE
                    document.body.removeChild(a);
                    query.updateStatus(EksamenFileStatus.Downloaded);
                }
            } else {
                Log("Wrong password: " + query.modalpassword);
                query.updateStatus(EksamenFileStatus.WrongPassword);
            }

        } else {
            Log(xhr.readyState);
            Log(xhr.status);
        }

    };

    var data = JSON.stringify({ "SiteUrl": "" + query.ExSPSiteURL + "", "ListId": "" + query.ExListID + "", "ItemId": "" + query.ExListItemID + "", "DocumentGuid": "" + query.DocumentGuid + "", "Documentversion": "" + query.ExUIVersionStringOWSTEXT + "" });
    Log("Before xhr.send - data:" + data);
    xhr.send(data);

}


async function getEksamenFile(query: EksamensFileQuery) {
    query.updateStatus(EksamenFileStatus.DownloadStarted);

    Log("Laster ned            : " + query.ExSPSiteURL);
    Log("ListID                : " + query.ExListID);
    Log("ListItemID            : " + query.ExListItemID);
    Log("UIVersionStringOWSTEXT: " + query.ExUIVersionStringOWSTEXT);
    Log("modalpassword         : " + query.modalpassword);
    Log("IsPasswordProtected   : " + query.ExIsPasswordProtected);
    Log("Passord               : " + query.ExPassord);
    Log("FileName              : " + query.filnavn);

    Log(query.modalpassword);
    const response = await geteksamensoppgavefrompgsd(query.ExSPSiteURL, query.ExListID, query.ExListItemID, query.DocumentGuid, query.ExUIVersionStringOWSTEXT, query.modalpassword, query.ExIsPasswordProtected, query.ExPassord)
    const result = await response.text();
    //const bearertoken = "{\"FileName\":\"Dokument.docx\",\"MimeType\":\"application/vnd.openxmlformats-officedocument.wordprocessingml.document\",\"DocumentGuid\":\"{8A82201A-B27A-401A-AD6D-160D10808EF5}\",\"DocumentVersion\":\"12.0\",\"FileBinary\":\"UEsDBB\"}"; 
    Log("RESULT:");
    Log(result);
    if (result.toString() === "Feil passord" || result.toString().indexOf("Feil passord") !== -1) {
        Log("Wrong password: " + query.modalpassword);
        query.updateStatus(EksamenFileStatus.WrongPassword);
        return;
    } else if (result.toString().indexOf("result.StatusCode:Forbidden") !== -1) {
        Log("StatusCode is: Forbidden");
        query.updateStatus(EksamenFileStatus.DownloadError);
        return;
    } else if (result.toString().indexOf("result.StatusCode:BadGateway") !== -1) {
        Log("StatusCode is: BadGateway");
        query.updateStatus(EksamenFileStatus.DownloadError);
        return;
    } else {
        query.updateStatus(EksamenFileStatus.CorrectPassword);
    }
    
    var jsondata = JSON.parse(result);
    Log(jsondata);

    const resolvedFileName = (query.filnavn && query.filnavn.trim().length > 0)
        ? query.filnavn
        : ((jsondata.FileName && jsondata.FileName.trim().length > 0) ? jsondata.FileName : 'eksamensfil.pdf');

    var applicationType = jsondata.MimeType;
    var binaryFile;
    if(jsondata.SasTokenUrl){
        Log("WE HAVE SasTokenUrl");
        const sasResponse = await fetch(jsondata.SasTokenUrl);
        if (!sasResponse.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await sasResponse.arrayBuffer();
        var binaryString = '';
        var bytes = new Uint8Array(data);
        for (var i = 0; i < bytes.byteLength; i++) {
            binaryString += String.fromCharCode(bytes[i]);
        }
        binaryFile = btoa(binaryString);
    }else{
        console.log("WE HAVE FileBinary");
        binaryFile = jsondata.FileBinary;
    }
    
    // Process Binary File
    var binaryFileDecoded = atob(binaryFile);
    var byteNumbers = new Array(binaryFileDecoded.length);
    for (var j = 0; j < binaryFileDecoded.length; j++) {
        byteNumbers[j] = binaryFileDecoded.charCodeAt(j);
    }
    var byteArray = new Uint8Array(byteNumbers);

    var file = new Blob([byteArray], { type: applicationType });
    if (file.size > 0) {
        Log(query.innholdstype);
        if(query.modalpassword && query.innholdstype !== "Sensorskolering") {
            sessionStorage.setItem('udirsokeksamensessionpassword', query.modalpassword);
        }
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            Log("MOBILE DOWNLOAD");
            window.parent.location.href = URL.createObjectURL(file);
            query.updateStatus(EksamenFileStatus.Downloaded);
        }
        //@ts-ignore
        else if (window.navigator.msSaveOrOpenBlob) {  // For IE
            Log("IE DOWNLOAD:" + resolvedFileName);
            window.navigator.msSaveOrOpenBlob(file, resolvedFileName);
            query.updateStatus(EksamenFileStatus.Downloaded);
        }
        else {
            Log("OTHER DOWNLOAD 2");
            var a = window.document.createElement("a");
            a.href = window.URL.createObjectURL(file);
            a.download = resolvedFileName;
            Log(resolvedFileName);
            document.body.appendChild(a);
            a.click();  // IE
            document.body.removeChild(a);
            query.updateStatus(EksamenFileStatus.Downloaded);
        }
    } else {
        Log("Wrong password: " + query.modalpassword);
        query.updateStatus(EksamenFileStatus.WrongPassword);
    }
}



function geteksamensoppgavefrompgsd(siteurl, listid, listitemid, docguid, docversion, password, passwordprotected, encpass) {
    if (passwordprotected == null) { passwordprotected = "false"; }
    Log("geteksamensoppgavefrompgsd siteurl          : " + siteurl);
    Log("geteksamensoppgavefrompgsd listid           : " + listid);
    Log("geteksamensoppgavefrompgsd listitemid       : " + listitemid);
    Log("geteksamensoppgavefrompgsd documentguid     : " + docguid);
    Log("geteksamensoppgavefrompgsd documentversion  : " + docversion);
    Log("geteksamensoppgavefrompgsd password         : " + password);
    Log("geteksamensoppgavefrompgsd passwordprotected: " + passwordprotected);
    Log("geteksamensoppgavefrompgsd encpass          : " + encpass);
    let protocolAndHostname = window.location.protocol + '//' + window.location.hostname;
    if(window.location.hostname === "localhost"){
        protocolAndHostname = "https://dev-sokeresultat.udir.no";
    }
    //const encodedPassword = encodeURIComponent(password);
    //return fetch(protocolAndHostname + '/Eksamen.ashx?siteurl=' + siteurl + "&listid=" + listid + "&listitemid=" + listitemid + "&docguid=" + docguid + "&docversion=" + docversion + "&password=" + encodedPassword + "&passwordprotected=" + passwordprotected+ "&encyid=" + encpass, { headers: { 'Accept': 'application/json;odata=nometadata;charset=utf-8' } });
    return fetch(protocolAndHostname + '/Eksamen.ashx?siteurl=' + siteurl + "&listid=" + listid + "&listitemid=" + listitemid + "&docguid=" + docguid + "&docversion=" + docversion + "&password=" + password + "&passwordprotected=" + passwordprotected+ "&encyid=" + encpass, { headers: { 'Accept': 'application/json;odata=nometadata;charset=utf-8' } });
}


export default getEksamenFile;
